import * as yup from 'yup';

const MESSAGES = {
    required: 'O campo é obrigatório',
    ataRequired: 'É obrigatório anexar a ata de aprovação quando há valores informados',
    afMaiorQueTotal: 'O valor da Agricultura Familiar não pode ser maior que o Total correspondente'
}

const schoolFeedingValidationSchema = yup.object().shape({
    // Campos obrigatórios - aceita 0
    alimentacao_af_recurso_pnae: yup
        .number()
        .nullable()
        .required('O campo "Recurso do PNAE Federal (Agricultura Familiar)" é obrigatório')
        .min(0.01, 'O valor deve ser maior que zero')
        .test(
            'af-pnae-menor-que-total',
            'O valor do PNAE Federal da Agricultura Familiar não pode ser maior que o Total do PNAE Federal',
            function (value) {
                const { alimentacao_total_recurso_pnae } = this.parent;
                if (value != null && alimentacao_total_recurso_pnae != null) {
                    return Number(value) <= Number(alimentacao_total_recurso_pnae);
                }
                return true;
            }
        ),



    alimentacao_af_recurso_prefeitura: yup
        .number()
        .nullable()
        .required('O campo "Recurso da Prefeitura (Agricultura Familiar)" é obrigatório')
        .min(0.01, 'O valor deve ser maior que zero')
        .test(
            'af-prefeitura-menor-que-total',
            'O valor da Prefeitura da Agricultura Familiar não pode ser maior que o Total da Prefeitura',
            function (value) {
                const { alimentacao_total_recurso_prefeitura } = this.parent;
                if (value != null && alimentacao_total_recurso_prefeitura != null) {
                    return Number(value) <= Number(alimentacao_total_recurso_prefeitura);
                }
                return true;
            }
        ),

    alimentacao_total_recurso_pnae: yup
        .number()
        .nullable()
        .required('O campo "Total de Recursos PNAE Federal" é obrigatório')
        .min(0.01, 'O valor deve ser maior que zero'),

    alimentacao_total_recurso_prefeitura: yup
        .number()
        .nullable()
        .required('O campo "Total de Recursos da Prefeitura" é obrigatório')
        .min(0.01, 'O valor deve ser maior que zero'),

    // Campos opcionais
    alimentacao_af_recurso_estado: yup
        .number()
        .nullable()
        .min(0, 'O valor deve ser maior ou igual a zero')
        .test(
            'af-estado-menor-que-total',
            'O valor do Estado da Agricultura Familiar não pode ser maior que o Total do Estado',
            function (value) {
                const { alimentacao_total_recurso_estado } = this.parent;
                if (value != null && alimentacao_total_recurso_estado != null) {
                    return Number(value) <= Number(alimentacao_total_recurso_estado);
                }
                return true;
            }
        ),

    alimentacao_total_recurso_estado: yup
        .number()
        .nullable()
        .min(0, 'O valor deve ser maior ou igual a zero'),

    // Validação condicional da ata - obrigatória se há valores informados
    alimentacao_ata_aprovacao_uuid: yup
        .string()
        .required(MESSAGES.required)
});

export default schoolFeedingValidationSchema;